import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import VueRouter from 'vue-router'
import router from './router'
import Communicator from './libraries/apiCom.js'
import Actions from './libraries/apiActions.js'
import VueCookies from 'vue-cookies'
import valid from './libraries/validFormat' 
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import './assets/hire.css';
import "./assets/theme.css";
import { HMSReactiveStore } from '@100mslive/hms-video-store';
import VueMeta from 'vue-meta'

const hms = new HMSReactiveStore();
const hmsStore = hms.getStore();
const hmsActions = hms.getHMSActions();
const hmsNotifications = hms.getNotifications();


Vue.config.productionTip = false
Vue.use(BootstrapVue);
Vue.use(Vuetify);
Vue.use(VueCookies);
Vue.use(VueRouter);
Vue.use(VueMeta);

Vue.prototype.$apiCom = Communicator
Vue.prototype.$apiAction = Actions
Vue.prototype.$valid= valid
Vue.prototype.hmsStore = hmsStore;
Vue.prototype.hmsActions = hmsActions;
Vue.prototype.hmsNotifications = hmsNotifications;
Vue.prototype.$S3_url= process.env.VUE_APP_S3_URL;
Vue.prototype.$S3_bucket_url = process.env.VUE_APP_S3_BUCKET_URL;

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

new Vue({
  router: router,
  vuetify: new Vuetify(),
  render: h => h(App),
}).$mount('#app')

import vueStickySidebar from "vue-sticky-sidebar";

export default {
  name: "ServeDev",
  components: {
    "vue-sticky-sidebar": vueStickySidebar
  }
};